import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuardService } from './shared/services/auth-guard.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthGuardService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      // console.log('Next Check: ', next);
      // console.log('State Check: ', state);

      if (state.url === '/admin/bank-admin/bankWiseLoanDisbursed') {
        return true;
      }

      if (!this.authService.isLoggedIn()) {
        this.router.navigate(['/login']);
        return false;
      }
    return true;
  }
}
